import React, { useEffect, useState } from "react";
import axios from "axios";
import { Prod01 } from "../constants/ActionType";

// Uploaded files are served only through the authenticated GET /general/file/:fileName endpoint;
// axios carries the bearer token, so <img src> / window.open with a bare URL would get 401.
export const fetchProtectedFileUrl = async (fileName) => {
  const res = await axios.get(`${Prod01}/general/file/${encodeURIComponent(fileName)}`, { responseType: "blob" });
  return URL.createObjectURL(res.data);
};

export const openProtectedFile = async (fileName) => {
  if (!fileName) return;
  const win = window.open("", "_blank");
  try {
    const url = await fetchProtectedFileUrl(fileName);
    if (win) win.location = url; else window.location = url;
  } catch (e) {
    if (win) win.close();
    const status = e?.response?.status;
    alert(status === 403 ? "You are not allowed to open this file." : status === 401 ? "Please log in again." : status === 404 ? "File not found." : "File could not be opened.");
  }
};

export const ProtectedImg = ({ fileName, ...imgProps }) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let url;
    let cancelled = false;
    setSrc(null);
    if (fileName) {
      fetchProtectedFileUrl(fileName).then((u) => { url = u; if (!cancelled) setSrc(u); else URL.revokeObjectURL(u); }).catch(() => {});
    }
    return () => { cancelled = true; if (url) URL.revokeObjectURL(url); };
  }, [fileName]);
  if (!src) return null;
  return <img src={src} alt="" {...imgProps} />;
};
